import { TilsynState } from "./types";

const initialState: TilsynState = {
      tilsynLoading: [],
      tilsynPlanned: [],
      fail: false
  };

  export default initialState;